const state = () => {
  return {
    sc_holidays: [],
    sc_holiday: {},
    sc_holiday_filters: {},
  }
}

export default state;
